import { appendScript } from "@stadium/helpers/script-loader";

const wistiaUrlPattern = /.*\/(?<id>.*)/i;

export const fetchWistiaVideo = (wistiaId) => {
  appendScript(`https://fast.wistia.com/embed/medias/${wistiaId}.jsonp`);
  appendScript("https://fast.wistia.com/assets/external/E-v1.js");
};

/* uses oEmbed spec */
export const getWistiaVideoId = (oEmbedVideo) =>
  oEmbedVideo?.provider_name?.includes("Wistia") &&
  wistiaUrlPattern.exec(oEmbedVideo.embed_url)?.groups?.id;

export const getWistiaPlayerLink = (wistiaId) => `https://fast.wistia.net/embed/iframe/${wistiaId}`;
